app.controller("CampaignFormController",
    ["$scope", "$http", "$window", function($scope, $http, $window) {

		$scope.submitUrl = document.querySelector("link[rel='canonical']").href;
		$scope.thank_you = false;
		$scope.submitted = false;

        $scope.submitForm = function() {

			var errors = {
				email: 'Virheellinen sähköpostiosoite',
				phone: 'Syötä puhelinnumero',
				name: 'Syötä nimi',
				address: 'Syötä osoite',
				postCode: 'Syötä postinumero',
				city: 'Syötä postitoimipaikka'
			};
			if ($scope.errors == null) {
				$scope.errors = {};
			}

			var formData = {
				message: $scope.message || "",
				email: $scope.email || "",
				phone: $scope.phone || "",
				name: $scope.name || "",
				address: $scope.address || "",
				postCode: $scope.postCode || "",
				city: $scope.city || "",
				newsletter: $scope.newsletter || "",
				formID: 'campaignForm',
				subject: $scope.subject || "",
				recipient: $scope.recipient || "",
				submitPath: $scope.submitUrl
			};
			if ($window.wakeTestEmail !== undefined) {
				formData.wakeTestEmail = $window.wakeTestEmail;
			}

            $http({
                method: "POST",
                url: "/api/km/KMSite/processForm",
                data: formData
            })
            .then(function(data) {
				$scope.errors = {};
				$scope.thank_you = true;		
				$scope.submitted = true;

				if ($scope.newsletter) {
					/* Tilattu uutiskirje */
					// adf.ClickTrack(this, 342679, 'Uutiskirjeen Tilaus',{});
					_gaq.push(['_trackEvent', 'Uutiskirje', 'Lähetä']);
				}
            }, 
	        function(results) {
				for(var key in results.data.data) {
					if(!results.data.data[key].success) {
						$scope.errors[key] = errors[key];
					} else {
						$scope.errors[key] = null;
					}
				}
            });
		};
    }]
);
